import AuthMiddleware from "@/middleware/auth";

const AllHospitals = () =>
  import(
    /* webpackChunkName: "hospital" */ "@/views/hospitals/AllHospitals.vue"
  );
const ActiveHospitals = () =>
  import(
    /* webpackChunkName: "hospital" */ "@/views/hospitals/ActiveHospitals.vue"
  );
const InActiveHospitals = () =>
  import(
    /* webpackChunkName: "hospital" */ "@/views/hospitals/InActiveHospitals.vue"
  );
const HospitalRouter = [
  {
    path: "/ordering-facilities",
    name: "AllHospitals",
    component: AllHospitals,
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "ORDERING FACILITIES",
    },
  },
  {
    path: "/ordering-facilities/active",
    name: "ActiveHospitals",
    beforeEnter: AuthMiddleware.user,
    component: ActiveHospitals,
    meta: {
      title: " ORDERING FACILITIES",
    },
  },
  {
    path: "/ordering-facilities/inactive",
    name: "InActiveHospitals",
    beforeEnter: AuthMiddleware.user,
    component: InActiveHospitals,
    meta: {
      title: "ORDERING FACILITIES",
    },
  },
];

export { HospitalRouter };
